import type { AnySceneObjectT, SimpleStyleT } from "tweenly"
import Box from "@mui/material/Box"
import ExpandableSection from "../../../common/ExpandableSection"
import ColorField from "../../../common/PropertyTools/ColorField"
import PropertyRow from "../../../common/PropertyTools/PropertyRow"

export type ColorEventT = {
    target: { name: string; value: any }
}

interface Props {
    title?: string
    object: AnySceneObjectT
    handleSetValue: (property: any, value: any) => void
}

/** The color of a text or a line as one compact row — swatch, hex and its alpha in %. */
const TextColor = ({ title, object, handleSetValue }: Props) => {
    const color: SimpleStyleT | undefined = object.styles.find(
        (style) => style.property === "color" || style.property === "backgroundColor"
    )

    if (!color) return <></>

    const handleOnChange = (e: ColorEventT) => handleSetValue(e.target.name, e.target.value)

    return (
        <ExpandableSection
            expanded={true}
            title={title ?? "Color"}
            component={
                <Box width="100%" pb={0.5}>
                    <PropertyRow>
                        <ColorField styleProperty={color} handleOnChange={handleOnChange} />
                    </PropertyRow>
                </Box>
            }
        />
    )
}

export default TextColor
